module.exports = (cb, ms) => {
    let timeoutId
    let realArgs
    const doWork = () => {
        timeoutId = null
        cb.apply(null, realArgs)
    }

    return (...args) => {
        realArgs = args
        if (timeoutId)
            return
        timeoutId = setTimeout(doWork, ms)
    }
}


// WEBPACK FOOTER //
// ./src/utils/throttle.js